import type { Brand } from '@mathflat/domain/Brand'
import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'

import { envUtils } from '~/@common/utils/envUtils'

const envSuffix = envUtils.isLive ? '' : envUtils.isStaging ? '-staging' : '-dev'

// 스쿨플랫 호스트에서도 TARGET_DOMAIN 은 mathflat.com 이다.
const brandDomain = (brand: Brand) =>
  brand === 'SCHOOLFLAT' ? 'schoolflat.com' : domainProvider.TARGET_DOMAIN

const currentBrand: Brand = envUtils.isSchool ? 'SCHOOLFLAT' : 'MATHFLAT'

export const outerLinks = {
  스쿨플랫_학생앱_사용_가이드_링크:
    'https://hill-structure-ae3.notion.site/1c3f64225de481a5b55ecb82e74fc646',
  크레버스_학생_로그인_링크: envUtils.isLive
    ? 'https://account.creverse.com/mglogin'
    : 'https://accountvlc.cdwide.com/mglogin',
  /** 브랜드를 모르면 지금 떠 있는 브랜드의 선생님 웹 */
  선생님_웹_origin: (brand: Brand | null) =>
    `https://teacher${envSuffix}.${brandDomain(brand ?? currentBrand)}`,
  /** 브랜드를 모르거나 지금 떠 있는 브랜드면 현재 origin 을 그대로 쓴다(로컬·프리뷰 포함). */
  학생_웹_origin: (brand: Brand | null) =>
    brand === null || brand === currentBrand
      ? window.location.origin
      : `https://student${envSuffix}.${brandDomain(brand)}`,
}
